// extracted by mini-css-extract-plugin
module.exports = {"max_width":"bulk-processing_max_width__3OObB","pageContainer":"bulk-processing_pageContainer__26SVJ","mainTitle":"bulk-processing_mainTitle__1kGGz"};